import React, { Dispatch, SetStateAction } from "react";
import { NavLink} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NavigationIcon, NavigationId, NavigationType } from "@/enums";

import dashboardIcon from "@/images/icons/nav-home.svg"; 
import reportsIcon from "@/images/icons/nav-reports.svg";
import settingsIcon from "@/images/icons/nav-settings.svg";
import logoutIcon from "@/images/icons/nav-logout.svg";

export interface LeftNavItem {
    type: NavigationType;
    icon: NavigationIcon;
    displayName: string;
    idName: NavigationId;
    route?: string;
    sequenceNum: number;
    action?: () => void;
}

export interface LeftNavItemProps {
    type: NavigationType;
    icon: NavigationIcon;
    displayName: string;
    idName: NavigationId;
    route?: string;
    isCollapsed: boolean;
    isActive: boolean;
    setActiveItem: Dispatch<SetStateAction<NavigationId>>;
    action?: () => void;
}

export const LefthandGlobalNavItem: React.FC<LeftNavItemProps> = (item) => {

    const { t } = useTranslation(['navigation']);
    const icon = item.icon;

    const itemContent = (<>
        <span className="nav-icon">
        {<img src={
            icon === NavigationIcon.SETTINGS ? settingsIcon : 
            icon === NavigationIcon.LOGOUT ? logoutIcon : 
            icon === NavigationIcon.DASHBOARD ? dashboardIcon : 
            reportsIcon
          } alt={t(item.displayName) ?? item.displayName} />}        
          </span>
        <span className="text">
          {t(item.displayName)}
        </span>
    </>);

    const itemEl = (item: LeftNavItemProps) => {
      if (item.type === "button") {
        return (<button type="button" className="btn btn-link" onClick={ () => { item.setActiveItem(item.idName); if (item.action) { item.action(); } }}>{itemContent}</button>);
      } else {
        const target = item.type === "link-external" ? "_blank" : "";
        if (item.type === "link-external"){
          return (<a href={item.route} target={target}>{itemContent}</a>);
        }
        return (<NavLink to={`${item.route}`}>{itemContent}</NavLink>);
      }
    };

    return (
        <li className={`aec-lefthand-global-nav-item ${item.isCollapsed ? "collapsed" : ''} ${item.isActive ? "active" : ''}`}>
            {itemEl(item)}
        </li>
    );
};